import { render, staticRenderFns } from "./c-crop.vue?vue&type=template&id=45570dc4"
import script from "./c-crop.vue?vue&type=script&lang=js"
export * from "./c-crop.vue?vue&type=script&lang=js"
import style0 from "./c-crop.vue?vue&type=style&index=0&id=45570dc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports